import orderInstance from '../instance'

const printRequest = (data) => {
	return orderInstance.post('/printRequests', data)
}

export default printRequest
